import { render, staticRenderFns } from "./updateAnswer.vue?vue&type=template&id=2b65efe0"
import script from "./updateAnswer.vue?vue&type=script&lang=js"
export * from "./updateAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports